import { appConstants } from "../_constants";


const initialState = {
    balance: 0
};

export function wallet(state = initialState, action) {
    switch (action.type) {
        case appConstants.SET_WALLET_BALANCE:
            return {
                ...state,
                balance: action.balance
            };
        default:
            return state;
    }
}
